import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import AddIcon from '@material-ui/icons/AddCircle';
import RemoveIcon from '@material-ui/icons/RemoveCircle';

const useStyles = makeStyles(theme => ({
  root: {
    // marginBottom: theme.spacing(4)
  },
  media: {
    transition: 'height 0.5s',
    backgroundColor: '#ddd'
  },
  mediaClosed: {
    height: 140,
  },
  mediaOpen: {
    height: 240,
  },
  content: {
    padding: theme.spacing(3)
  },
  text: {
    minHeight: '112px'
  },
  title: {
    marginBottom: theme.spacing(1)
  },
  company: {
    fontWeight: 300
  },
  location: {
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
    fontWeight: 400
  },
  description: {
    whiteSpace: 'pre-line',
    marginTop: theme.spacing(1),
    fontSize: '0.9em'
  },
  button: {
    textTransform: 'none'
  },
}));
export default (props) => {
  const [isOpen, setOpen] = useState(false);
  const [isHover, setHover] = useState(false);

  const classes = useStyles();
  return (
    <Card className={classes.root} onMouseEnter={e => setHover(true)} onMouseLeave={e => setHover(false)}>
      <CardMedia
        className={`${classes.media} ${isOpen || isHover ? classes.mediaOpen : classes.mediaClosed}`}
        image={props.config.imageUrl || ""}
        title={props.config.title}
      />
      <CardContent className={classes.content}>
        <div className={classes.text}>
          {props.config.location &&
            <h6 className={classes.location}>{props.config.location}</h6>
          }
          <h4 className={classes.title}>{props.config.title}</h4>
          <h5 className={classes.company}>{props.config.company}</h5>
        </div>
        {!isOpen &&
          <Button color="primary" className={classes.button} startIcon={<AddIcon />} onClick={e => setOpen(!isOpen)} > show more </Button>
        }
        {isOpen &&
          <Button color="primary" className={classes.button} startIcon={<RemoveIcon />} onClick={e => setOpen(!isOpen)} > show less </Button>
        }
        <Collapse in={isOpen}>
          <Typography variant="body2" color="textSecondary" component="p" className={classes.description}>
            {props.config.description}
          </Typography>
        </Collapse>
      </CardContent>
    </Card>
  );
}
